export const getBuyOrViewProductMetaTag = (
  action: 'buy' | 'view',
  retailerName?: string,
  productName?: string,
  productId?: string,
  stacklineSku?: string,
  productUrl?: string,
  productPrice?: number,
) => {
  return {
    id: `${retailerName}_${action}`,
    'data-vendor': retailerName,
    'data-action': action,
    'data-product-name': productName,
    'data-product-id': productId,
    'data-stackline-sku': stacklineSku,
    'data-product-url': productUrl,
    'data-product-price': productPrice,
  };
};
